document.addEventListener('DOMContentLoaded', () => {
    // 数据初始化，定义变量
    const shippingData = window.productData.variants;
    const fabricData = JSON.parse(document.getElementById('fabric-json').textContent);
    const shippingLabel = document.getElementById('shipping_time_calculator');
    const swatchItems = document.querySelectorAll('.t4s-swatch__item');
    const modifyTime = document.getElementById('shipping-time');
    const shippingTipBtn = document.getElementById('shipping-tooltip');
    const shippingPopup = document.getElementById('shipping-policy-dialog');

    let timeStr ='';

    // 统一状态：当前选中的 fabric / recliner（由点击直接驱动）
    const state = { fabric: null, recliner: null };

    // 计算交付时间
    function calculateShipping(timeArray) {
        // 计算时间范围
        const { min, max } = getMinMax(timeArray);

        //const reclinerNum = recliner ? parseInt(recliner.replace(/[^\d]/g, ''),10) : 0; // 获取选项中的数字,并将数字转换为整数类型

        // 根据 timeArray 的长度来确定时间格式
        timeStr = (timeArray.length === 1) ? `${formatDurationToWeeksDays(timeArray[0], false)}.` : `${formatDurationToWeeksDays(min, true)}-${formatDurationToWeeksDays(max, false)}.`;

        return timeStr;
    }

    // 计算列表最大值和最小值
    function getMinMax(arr) {
        if (arr.length === 1) return { min: arr[0], max: arr[0] };

        const sorted = [...arr].sort((a, b) => a - b);
        return { min: sorted[0], max: sorted[sorted.length - 1] };
    }

    // 计算天数，7的倍数显示weeks，不足7的部分显示days
    function formatDurationToWeeksDays(day, isMin) {
        const weeks = Math.floor(day / 7);
        const remainingDays = day % 7;

        if (weeks > 0 && remainingDays > 0) {
            return `${weeks}${isMin ? '' : ' weeks'} ${remainingDays} days`;
        }

        if (weeks > 0) {
            return `${weeks}${isMin ? '' : ' weeks'}`;
        }

        return `${day}${isMin ? '' : ' days'}`;
    }

    // 主流程：更新交付时间  用“本次点击的值”去更新
    function updateDeliveryTime(overrides = {}) {
        if (overrides.fabric !== undefined) state.fabric = overrides.fabric;
        // if (overrides.recliner !== undefined) state.recliner = overrides.recliner;

        // 如果初始化时还没通过点击设置过，就兜底从页面当前 selected 取一次
        if (!state.fabric) {
            state.fabric = document.querySelector('.is-t4s-name__fabric-color .is--selected')?.dataset.value || null;
        }
        // if (!state.recliner) {
        //     state.recliner = document.querySelector('.is-t4s-name__recliners .is--selected')?.dataset.value || null;
        // }

        //if (!state.fabric || !state.recliner) return; // 如果两个为空则跳过
        if (!state.fabric) return;

        const matched = fabricData.find(item => item.fabric_name.toLowerCase() === state.fabric.toLowerCase());
        if (!matched) return;

        // 检查matched.delivery_time是否存在且不为空，不满足条件则设置时间数组为0
        const timeArray = (matched.delivery_time && matched.delivery_time.length) ? matched.delivery_time : [0];
        if (timeArray != 0) {
            calculateShipping(timeArray);
            shippingLabel.removeAttribute('style');
        } else {
            shippingLabel.style.display = "none";
        }

        // 获取路径的variant的id
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        const hasTime = shippingData.find(item => item.id === variantId);
        if (!modifyTime) return;

        const hasOverride = variantId && shippingData && hasTime;
        modifyTime.textContent = hasOverride ? hasTime.shipping_time : (modifyTime.dataset.value || timeStr);

    }

    // 初始化
    updateDeliveryTime();
    // console.log(timeStr);
    // 监听选择变化
    swatchItems.forEach(item => {
        item.addEventListener('click', () => {
            const value = item.dataset.value;
            // 判断点击的是 fabric 还是 recliner（根据它所在的容器）
            const isFabric = Boolean(item.closest('.is-t4s-name__fabric-color'));
            // const isRecliner = Boolean(item.closest('.is-t4s-name__recliners'));

            // 用 requestAnimationFrame 让 UI 的 selected class（如果有）先完成切换（更稳）,实现同步刷新，不会导致下次点击获取的是上一次获取的数据
            requestAnimationFrame(() => {
                if (isFabric) updateDeliveryTime({ fabric: value });
                // else if (isRecliner) updateDeliveryTime({ recliner: value });
                else updateDeliveryTime(); // 兜底
            });
        });
    });

    // 监听路由变化,通过variant查找对应的variant_id
    const originalPushState = history.pushState;
    history.pushState = function() {
        originalPushState.apply(this, arguments);
        updateDeliveryTime();
    };

  window.addEventListener('popstate', updateDeliveryTime());


    // 监听提示按钮的点击
    const togglePopup = () => {
        // shippingPopup.style.display = shippingPopup.style.display === 'none' ? 'block' : 'none';
        shippingPopup.classList.toggle('show');
    };
    if (!shippingTipBtn) return;
    shippingTipBtn.addEventListener('click', togglePopup);
    const closeBtn = document.getElementById('dialog-close');
    closeBtn.addEventListener('click', togglePopup);
});